import { render, staticRenderFns } from "./comparativeDetails.vue?vue&type=template&id=4d375514&scoped=true"
import script from "./comparativeDetails.vue?vue&type=script&lang=js"
export * from "./comparativeDetails.vue?vue&type=script&lang=js"
import style0 from "./comparativeDetails.vue?vue&type=style&index=0&id=4d375514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d375514",
  null
  
)

export default component.exports